import { Check } from 'lucide-react';

export function titleCaseKey(key) {
  return String(key).split('_').filter(Boolean).map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

// catalogGroups is the { [groupName]: [{ key, label }] } shape from
// GET /admin/feature-catalog — used where the server hasn't already
// attached featureGroups to the plan (the super-admin plan cards).
export function groupKeysByCatalog(keys = [], catalogGroups = {}) {
  const wanted = new Set(keys);
  const out = [];
  for (const [group, items] of Object.entries(catalogGroups)) {
    const present = items.filter((f) => wanted.has(f.key)).map((f) => ({ key: f.key, label: f.label }));
    if (present.length) out.push({ group, items: present });
    items.forEach((f) => wanted.delete(f.key));
  }
  if (wanted.size) out.push({ group: 'Other', items: [...wanted].map((key) => ({ key, label: titleCaseKey(key) })) });
  return out;
}

export default function PlanFeatureGroups({ groups = [], compact = false }) {
  if (!groups.length) return null;
  return (
    <div className={compact ? 'space-y-3' : 'space-y-4'}>
      {groups.map(({ group, items }) => (
        <div key={group}>
          <div className="text-[11px] font-bold text-[#706E6B] mb-1.5">{group}</div>
          <ul className="space-y-1.5">
            {items.map((f) => (
              <li key={f.key} className="flex items-center gap-2">
                <Check size={14} className="text-[#2E844A] shrink-0" strokeWidth={3} />
                <span className="text-[13px] text-[#5C5C5C] font-medium">{f.label}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
